import { render, staticRenderFns } from "./ComTemplateDataSource.vue?vue&type=template&id=421361ef&scoped=true&"
import script from "./ComTemplateDataSource.vue?vue&type=script&lang=js&"
export * from "./ComTemplateDataSource.vue?vue&type=script&lang=js&"
import style0 from "./ComTemplateDataSource.vue?vue&type=style&index=0&id=421361ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421361ef",
  null
  
)

export default component.exports